import { render } from "./InfoMessage.vue?vue&type=template&id=2febeb20&scoped=true"
const script = {}

import "./InfoMessage.vue?vue&type=style&index=0&id=2febeb20&scoped=true&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2febeb20"]])

export default __exports__